import React, { useState } from "react";
import NavigationBar from "../../components/element/NavigationBar";
import FBOHeaderBar from "../../components/element/FBOHeaderBar";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import useFBOApi from "../../services/api/useFBOApi";
import { useMutation, useQuery } from "@tanstack/react-query";
import SnackbarAlert from "../../components/element/SnackbarAlert";
import AddMeterDialog from "./Views/AddFuelMeterDialog";
import AddFuelMeterDataTable from "./Tables/AddFuelMeterDataTable";
import "./CSS/AddFuelMeterDialog.css";
import {
  ADD_FUEL_METER_SUCCESS_MESSAGE,
  FUEL_METER_READING_SUBMIT_MESSAGE,
} from "../../utils/constants";
import SubmitFuelMeterReadingDialog from "./Views/SubmitFuelMeterReadingDialog";
import ROUTE_PATHS from "../../utils/routePaths";

const AddFuelMeterData = () => {
  const [showAddMeterDialog, setShowAddMeterDialog] = useState(false);
  const [showSubmitReadingDialog, setShowSubmitReadingDialog] = useState(false);
  const [selectedMeter, setSelectedMeter] = useState(null);
  const [actionCount, setActionCount] = useState(0);
  const {
    fetchListOfFuelMeters,
    fetchAssociatedFboCustomers,
    addFuelMeterData,
    submitFuelReadingData,
  } = useFBOApi();

  const {
    data: fuelMetersData,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["fuel-meters-data-list", actionCount],
    queryFn: fetchListOfFuelMeters,
    retry: false,
  });

  const { data: associatedCustomers } = useQuery({
    queryKey: ["associated-fbo-customer-data-list"],
    queryFn: fetchAssociatedFboCustomers,
    retry: false,
  });

  const addFuelMeterMutation = useMutation({
    mutationFn: ({ data }) => addFuelMeterData(data),
    onSuccess: () => {
      setActionCount(actionCount + 1);
      setShowAddMeterDialog(false);
    },
  });

  const submitFuelReadingMutation = useMutation({
    mutationFn: ({ data }) => submitFuelReadingData(data),
    onSuccess: () => {
      setActionCount(actionCount + 1);
      setShowSubmitReadingDialog(false);
    },
  });

  const handleSubmitReadingClick = (item) => {
    setSelectedMeter(item);
    setShowSubmitReadingDialog(true);
  };

  const handleAddFuelMeterClick = (
    selectedCustomer,
    meterId,
    meterStartReading
  ) => {
    addFuelMeterMutation.mutate({
      data: {
        meterId: meterId,
        fboId: selectedCustomer?.id,
        fboName: selectedCustomer?.name,
        startReading: meterStartReading,
      },
    });
  };

  const handleSubmitFuelReadingClick = (endReading, fuelWastage, fuelRecirculation, fuelTesting) => {
    submitFuelReadingMutation.mutate({
      data: {
        meterId: selectedMeter?.meterId,
        endReading: endReading,
        fuelWastage: fuelWastage,
        fuelRecirculation: fuelRecirculation,
        fuelTesting: fuelTesting,
      },
    });
  };

  return (
    <div>
      {addFuelMeterMutation.isError ? (
        <SnackbarAlert type={"error"}>
          {addFuelMeterMutation.error.message}
        </SnackbarAlert>
      ) : (
        ""
      )}
      {addFuelMeterMutation.isSuccess ? (
        <SnackbarAlert type={"success"}>
          {ADD_FUEL_METER_SUCCESS_MESSAGE}
        </SnackbarAlert>
      ) : (
        ""
      )}
      {submitFuelReadingMutation.isError ? (
        <SnackbarAlert type={"error"}>
          {submitFuelReadingMutation.error.message}
        </SnackbarAlert>
      ) : (
        ""
      )}
      {submitFuelReadingMutation.isSuccess ? (
        <SnackbarAlert type={"success"}>
          {FUEL_METER_READING_SUBMIT_MESSAGE}
        </SnackbarAlert>
      ) : (
        ""
      )}
      <NavigationBar />
      <FBOHeaderBar
        title={"Add Meter"}
        backContent={
          <div className="navigation-header">
            <Link to={ROUTE_PATHS.FBO_HOME} className="navigation-header-link">
              Home/
            </Link>
            <Link
              to={ROUTE_PATHS.FUEL_ROYALTY_HOME}
              className="navigation-header-link"
            >
              Fuel Royalty/
            </Link>
            Add Meter
          </div>
        }
      />
      <div className="add-fuel-meter-data-button-container">
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowAddMeterDialog(true)}
        >
          Add Meter
        </Button>
      </div>
      <AddFuelMeterDataTable
        meterData={fuelMetersData?.data}
        isLoading={isLoading}
        error={error}
        onClickSubmit={handleSubmitReadingClick}
      />
      <AddMeterDialog
        open={showAddMeterDialog}
        onClose={() => setShowAddMeterDialog(false)}
        isLoading={addFuelMeterMutation?.isPending}
        associatedCustomers={associatedCustomers?.data}
        onClickAdd={handleAddFuelMeterClick}
      />
      <SubmitFuelMeterReadingDialog
        open={showSubmitReadingDialog}
        onClose={() => setShowSubmitReadingDialog(false)}
        isLoading={submitFuelReadingMutation?.isPending}
        onClickSubmit={handleSubmitFuelReadingClick}
      />
    </div>
  );
};

export default AddFuelMeterData;
